import * as React from "react";
import Header from "./header";
import Footer from "./footer";

export default function Layout({ children }) {
  return (
    <>
      <Header />
      <main className="transition-all duration-300">{children}</main>
      <Footer />
    </>
  );
}
